<template>
  <v-container class="d-flex align-center justify-center" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card elevation="10" class="pa-6">
          <v-card-title class="justify-center">
            <v-img src="/assets/logo.png" width="64" class="mb-2" />
          </v-card-title>

          <v-card-subtitle class="text-center mb-4">
            <h2 class="text-primary">Welcome Back</h2>
            <p class="text-grey-darken-1">Please sign in to continue</p>
          </v-card-subtitle>

          <v-form @submit.prevent="handleLogin">
            <v-text-field
              v-model="email"
              label="Email"
              type="email"
              prepend-inner-icon="mdi-email"
              required
              clearable
            />

            <v-text-field
              v-model="password"
              label="Password"
              type="password"
              prepend-inner-icon="mdi-lock"
              required
              clearable
            />

            <v-row justify="space-between" class="mt-2 mb-4">
              <v-col cols="6">
                <v-btn variant="text" class="text-grey" @click="$router.push('/forgot-password')">
                  Forgot password?
                </v-btn>
              </v-col>
              <v-col cols="6" class="text-right">
                <v-btn variant="text" class="text-grey" @click="$router.push('/signup')">
                  Create account
                </v-btn>
              </v-col>
            </v-row>

            <v-btn type="submit" color="primary" block class="mb-2">Login</v-btn>

            <div class="text-center text-grey text-caption my-2">or</div>

            <v-btn variant="outlined" color="primary" block>
              <v-icon start>mdi-google</v-icon>
              Login with Google
            </v-btn>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    handleLogin() {
      localStorage.setItem('isLoggedIn', 'true')
      this.$router.push('/')
    }
  }
}
</script>
<style scoped>

</style>
